import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { AddEditUserService } from '../../../../../services/add-edit-user.service';

import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'user-management-find-exist-user',
    templateUrl: './find-exist-user.component.html',
    styleUrls: ['./find-exist-user.component.scss']
})
export class FindExistUserComponent implements OnInit {
    @Output() User = new EventEmitter();
    arrowkeyLocation: any;
    isOpen: boolean;
    users: any;
    searchTerm: string;
    showDdl: boolean;

    validation = {
        userExist: ''
    }
    tempContent: any = [];
    constructor(private manageUser: AddEditUserService, private toaster: ToastrService) {
        this.arrowkeyLocation = 0;
    }

    @HostListener('window:keyup.enter')
    changeByEnterkey() {
        var _users = this.tempContent as any[];
        var user = _users[this.arrowkeyLocation];
        this.change(user)
    }

    change(user) {
        this.manageUser.isUserExists(1, (res) => {
            if (res == false) {
                this.showDdl = false;
                this.User.emit({ user: user })
            }

        }, (err) => { console.log(err); this.toaster.warning(err.Message) }, { firstName: user.FirstName, lastName: user.LastName, emailAddress: user.EmailAddress })
    }

    search(e) {
        if (e.target) {
            this.manageUser.searchSysUsers(1, this.searchTerm, (res) => {
                this.tempContent = res;
                this.showDdl = true;
            },
                (err) => {
                }
            )
        }
        else {
            this.tempContent = this.tempContent.filter(item => {
                if (item.key != undefined) {
                    return item.key.toLowerCase().startsWith(e.toLowerCase());
                }
            })
        }

    }

    @HostListener('window:keydown', ['$event'])
    onarrowDown(event) {
        if (event.key == 'ArrowDown') {
            if (this.arrowkeyLocation < this.tempContent.length - 1)
                return this.arrowkeyLocation++;
        }
        else {
            if (event.key == 'ArrowUp') {
                if (this.arrowkeyLocation > 0)
                    return this.arrowkeyLocation--;
            }
        }
    }

    ngOnInit() {
        this.users = [{ 'key': 'mohammed', 'value': '1' }, { 'key': 'malek', 'value': '2' }, { 'key': 'zaid', 'value': '3' }];
        this.searchTerm = "";
    }

}
